import { useEffect, useState } from "react";
import apiService from "src/services/ApiCallService";
import ErrorUtils from "src/utils/ErrorUtils";
import StringUtils from "src/utils/stringUtils";
import {CLIDetailsResult} from "src/models/calculations/CLIDetailsResult";

export default class CLIService {

    /**
     * One-shot, promise-based lookup of a CLI by calculation number, for callers acting on a click
     * (e.g. the LEF report's CLI → Calc Builder link). Same endpoint as the getCLIDetails hook.
     */
    async fetchCLIDetailsForCalculationNumber(calculationNumber: string): Promise<CLIDetailsResult> {
        const response = await apiService.getCLIDetailsForCalculationNumber(calculationNumber);
        return (await response.json()) as CLIDetailsResult;
    }

    getCLIs(query: string, status?: string, workbookId?: string, calculationStatus?: string) : [string[], boolean, string] {
        const [clis, setCLIs] = useState<string[]>([]);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState('');

        useEffect(() => {
            async function fetchData() {
                try {
                    setLoading(true);
                    const response = await apiService.getCLIs(status, workbookId, calculationStatus);
                    const json = await response.json();
                    setCLIs(json.clis.map((cli: string) => cli.toUpperCase()));
                }
                catch (ex) {
                    setError(ErrorUtils.getMessage(ex));
                }
                finally {
                    setLoading(false);
                }
            }
            if (!StringUtils.isNullOrEmpty(query)) {
                fetchData();
            }
        }, [query]);

        return [clis, loading, error];
    }

    getCLIDetails(calculationNumber?: string): [CLIDetailsResult, boolean, string] {
        const [results, setResults] = useState<CLIDetailsResult>(null as unknown as CLIDetailsResult);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState(null as unknown as string);
        useEffect(() => {
            async function fetchData() {
                try {
                    setLoading(true);
                    const response = await apiService.getCLIDetailsForCalculationNumber(calculationNumber);
                    const data = (await response.json()) as CLIDetailsResult;
                    setResults(data);
                }
                catch (ex:any) {
                    setError(ErrorUtils.getMessage(ex));
                }
                finally {
                    setLoading(false);
                }
            }

            if (!StringUtils.isNullOrEmpty(calculationNumber)) {
                fetchData();
            }
        }, [calculationNumber]);

        return [results, loading, error];
    }
}